define([
    'text!../views/mfp-wizard.html',
    'text!../views/mfp-risk-relevant-data.html',
    'text!../views/mfp-quote-details.html',
    'text!../views/mfp-personification-qualification.html',
    'text!../views/mfp-summary.html',
    'text!../views/mfp-confirmation.html',
    'text!edge/quoteandbind/common/views/contact-us.html',

    '../controllers/MFPWizardCtrl',
    '../controllers/MFPRiskRelevantDataCtrl',
    '../controllers/MFPQuoteDetailsCtrl',
    '../controllers/MFPPersonificationQualificationCtrl',
    '../controllers/MFPSummaryCtrl',
    '../controllers/MFPConfirmationCtrl',
    'edge/quoteandbind/common/controllers/ContactUsCtrl',
], (MFPWizardView, MFPRiskRelevantDataView, MFPQuoteDetailsView, MFPPersonificationQualificationView, MFPSummaryView, MFPConfirmationView, ContactUsView, // NOSONAR
    MFPWizardCtrl, MFPRiskRelevantDataCtrl, MFPQuoteDetailsCtrl, MFPPersonificationQualificationCtrl, MFPSummaryCtrl, MFPConfirmationCtrl, ContactUsCtrl)=> {
    return () => {
        const wizardParentState = 'baseQnbWizard';

        return {
            mfpRiskRelevantData: {
                parent: wizardParentState,
                url: '/mfp-relevant-data?vehicleType?retrievedByLink',
                params: {
                    vehicleType: null, //auto or motorcycle
                    retrievedByLink: null,
                },
                controller: MFPRiskRelevantDataCtrl,
                template: MFPRiskRelevantDataView,
                data: {
                    trackingUrl: () => {
                        return 'RiskRelevantData';
                    },
                },
            },
            mfpQuoteDetails: {
                parent: wizardParentState,
                url: '/mfp-quote-details',
                controller: MFPQuoteDetailsCtrl,
                template: MFPQuoteDetailsView,
                data: {
                    trackingUrl: () => {
                        return 'QuotingPage';
                    },
                },
            },
            mfpPersonificationQualification: {
                parent: wizardParentState,
                url: '/mfp-personification-qualification',
                controller: MFPPersonificationQualificationCtrl,
                template: MFPPersonificationQualificationView,
                data: {
                    trackingUrl: () => {
                        return 'PersonificationQualification';
                    },
                },
            },
            mfpSummary: {
                parent: wizardParentState,
                url: '/mfp-summary',
                controller: MFPSummaryCtrl,
                template: MFPSummaryView,
                data: {
                    trackingUrl: () => {
                        return 'SummaryPage';
                    },
                },
            },
            mfpConfirmation: {
                parent: wizardParentState,
                url: '/mfp-confirmation',
                controller: MFPConfirmationCtrl,
                template: MFPConfirmationView,
                data: {
                    hideNavigationBar: true,
                    trackingUrl: () => {
                        return 'ConfirmationPage';
                    },
                },
            },
            mfpContactUs: {
                url: '/mfp-contactus',
                parent: wizardParentState,
                controller: ContactUsCtrl, //still refering generic
                template: ContactUsView, //still refering generic
                params: {
                    returnStateInfo: null,
                    quoteID: null,
                },
                data: {
                    trackingUrl: '',
                },
            },
        };
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/config/RouteConfig.js